import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { MeasureFormat } from 'components/measure-unit/MeasureFormat';
import { Tile } from 'components/Layout/PageContainer';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/classNamesTailwind';

export interface BenchmarkMetricsRowProps {
  metrics: {
    title?: string;
    tenantName?: string;
    isTenant?: boolean;
    value: number;
    unit: MeasureUnitCode;
    hideSign?: boolean;
    isDiff?: boolean;
    subtitle?: string;
    timeRange?: string;
    isPerformanceGap?: boolean;
  }[];
  type: 'yoy' | 'mom' | 'returns' | 'cancellations';
}

const getUniqueKey = (metric: BenchmarkMetricsRowProps['metrics'][number]) =>
  [metric.tenantName, metric.title, metric.subtitle, metric.timeRange, metric.unit, metric.value]
    .filter(Boolean)
    .join('-');

export function BenchmarkMetricsRow({ metrics, type }: BenchmarkMetricsRowProps) {
  return (
    <Tile className="px-4 py-4 col-span-6 flex flex-row divide-x divide-gray-300">
      {metrics.map((metric, index) => (
        <div
          key={getUniqueKey(metric)}
          className={cn('flex-1 flex flex-col justify-between', index === 0 ? 'pl-0 pr-4' : 'px-4')}
          data-testid={`bm-metric-${type}-card-${index}`}
        >
          <div className="text-base font-bold flex flex-wrap gap-x-1 mb-8">
            {!metric.isPerformanceGap && metric.tenantName && (
              <span className={metric.isTenant ? 'text-turquoise-300' : 'text-darkBlue-600'}>{metric.tenantName}</span>
            )}
            {!metric.isPerformanceGap && metric.subtitle && <span className="text-gray-800">{metric.subtitle}</span>}
            {metric.isPerformanceGap && metric.title && <span>{metric.title} </span>}
            {metric.isPerformanceGap && (
              <div>
                {type === 'yoy' || type === 'mom' ? (
                  <span className={metric.isTenant ? 'text-turquoise-300' : 'text-darkBlue-600'}>
                    {metric.tenantName}
                  </span>
                ) : (
                  <span className="text-darkBlue-600">
                    <FormattedMessage id="benchmarking.benchmarks.all" />
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="flex items-center justify-start gap-x-3 mt-auto">
            <div className="text-2xl font-bold">
              <MeasureFormat
                value={metric.hideSign ? Math.abs(metric.value) : metric.value}
                unit={metric.unit}
                config={{
                  hasSign: !metric.hideSign,
                  isDiff: metric.isDiff,
                }}
              />
            </div>
            {metric.timeRange && <span className="text-sm text-gray-500 font-medium">{metric.timeRange}</span>}
          </div>
        </div>
      ))}
    </Tile>
  );
}
